import { Route, Routes } from 'react-router-dom';
import {Dashboard} from '../screens/Dashboard';
import { FC } from 'react';
import PublicRoute from './PublicRoute';
import Signout from '../layouts/Sidebar/Signout/Signout';

// function to return public react component
const getPublicRoute = (Component: FC) => (<PublicRoute><Component /></PublicRoute>);

const AppRoutes = () => {
  return (
    <Routes>
      <Route element={getPublicRoute(Dashboard)} path='/' />
      <Route path="/signout" element={<Signout/>} />
    </Routes>
  );
};

export default AppRoutes;
